import React from 'react';

function ContactSupportLink({ style }) {
  return (
        <div className="linkContainer textCenter" style={style}>
            <span className="link noDecoration">
                Need help?
           </span>
            <a target="blank" href="https://help.apester.com/" style={{ marginLeft: '2px' }} className="link">
                Contact support
            </a>
        </div>
  );
}

export default ContactSupportLink;
